import { z } from "zod";

export const getCanadianPayrollBusinessEntitySchema = z.object({
  companyID: z.string(),
});

export type TGetCanadianPayrollBusinessEntityRequest = z.infer<
  typeof getCanadianPayrollBusinessEntitySchema
>;

export type TGetCanadianPayrollBusinessEntityResponse = {
  success: boolean;
  business_entity: {
    id: string;
    business_number?: string;
    legal_registration_number?: string;
    name?: string;
    legal_name?: string;
    address_line_1?: string;
    address_line_2?: string;
    city?: string;
    province_code?: string;
    country_code?: string;
    postal_code?: string;
    contact_name?: string;
    contact_email?: string;
    contact_area_code?: string;
    contact_phone_number?: string;
    contact_extension?: string;
    pay_day_movement_setting?: string;
    vacation_pay_formula_setting?: string;
    remitter_type?: string;
    preferred_locale?: string;
    warnings?: {
      data: Record<
        string,
        {
          type: string;
        }
      >[];
    };
    [key: string]: unknown;
  };
};
